export default [
  {
    path: 'exam',
    name: 'exam',
    component: () => import('@/views/pages/exam/Exam.vue'),
    meta: {
      pageTitle: 'Exams',
      breadcrumb: [
        {
          text: 'Exams',
          active: true,
        },
      ],
      // resource: 'Exam',
    },
  },
  {
    path: 'exam/:id',
    name: 'exam-view',
    component: () => import('@/views/pages/exam/View.vue'),
    meta: {
      pageTitle: 'Exams',
      breadcrumb: [
        {
          to: { name: 'exam' },
          text: 'Exams',
          active: false,
        },
        {
          text: 'Exam',
          active: true,
        },
      ],
      // resource: 'Exam',
    },
  },
  {
    path: 'exam/:id/direction/:directionId',
    name: 'exam-direction',
    component: () => import('@/views/pages/exam/ViewDirection.vue'),
  },
]
